module.exports = __webpack_public_path__ + "img/7595fdeeae1068184459084dbd440532.png";